import { Link } from '@tanstack/react-router';
import { useRhinoContext } from '@rhino-project/core';
import { useHarborlightSession } from '../hooks/useHarborlightSession';

// Ported 1:1 from the source repository (client/src/pages/LandingPage.jsx).
// Standalone page: renders WITHOUT the app shell, exactly like the source.
const LandingPage = () => {
  const { user } = useRhinoContext();
  const { roleHomePath } = useHarborlightSession();

  return (
    <div className="app-shell">
      <nav className="navbar top-nav">
        <div className="container d-flex justify-content-between align-items-center">
          <span className="brand-mark fs-3">room stay 1</span>
          <div className="d-flex gap-2">
            {user ? (
              <Link className="btn btn-sea" to={roleHomePath}>
                Open console
              </Link>
            ) : (
              <>
                <Link className="btn btn-outline-sea" to="/login">
                  Sign in
                </Link>
                <Link className="btn btn-copper" to="/register">
                  Book as guest
                </Link>
              </>
            )}
          </div>
        </div>
      </nav>

      <main className="container py-4 py-lg-5">
        <section className="hero-panel p-4 p-lg-5 d-flex align-items-end fade-up">
          <div className="hero-content">
            <p className="text-uppercase small mb-2 opacity-75">
              Coastal stays · Calm operations
            </p>
            <h1 className="hero-brand">room stay 1</h1>
            <p className="hero-lead mb-4">
              A serene hotel workspace for guests to reserve rooms and for staff
              to run arrivals with clarity.
            </p>
            <div className="d-flex flex-wrap gap-2">
              <Link
                className="btn btn-light btn-lg px-4"
                to={user ? roleHomePath : '/register'}
              >
                {user ? 'Go to app' : 'Start a stay'}
              </Link>
              <Link className="btn btn-outline-light btn-lg px-4" to="/login">
                Staff login
              </Link>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default LandingPage;
